export const ApplicationVI = {
    "leaveReason":"Lý do nghỉ",
    "absenceReason":"Lý do vắng mặt",
    "inoutReason":"Lý do check in/check out",
    "missionsReason":"Lý do công tác",
    "vehicleMissionsReason":"Phương tiện công tác",
    "feesMissionsReason":"Công tác phí",
    "flexibleReason":"Lý do làm theo chế độ",
    "resignationReason":"Lý do xin nghỉ việc",
}